import * as React from 'react'
import { PlusOutlined, SaveOutlined } from '@ant-design/icons'
import { Button, Form, PageHeader } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { IUtenteBackofficeService } from '../../services/UtenteBackofficeService'
import { UtenteParams } from "./UtenteParams"
import { UtenteViewModel } from '../../models/UtenteModels'
import { FormUtente } from './edit/FormUtente'
import { ListClienteRole } from './edit/ListClienteRole'
import { ModalClienteRoleBackoffice } from './edit/ModalClienteRoleBackoffice'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'


class UtenteEditState extends UtenteViewModel {
    ModalVisible: boolean = false
}

export class PageUtenteEditBackofficeComp extends React.Component<RouteComponentProps<UtenteParams>, UtenteEditState> {

    service: IUtenteBackofficeService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_BACKOFFICE_SERVICE)
        this.state = new UtenteEditState()
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.loadData()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    loadData = async () => {
        let id = this.props.match.params.id
        return await this.service.Get(id)
    }

    onSaveClick = async () => {
        let resp = await this.service.Save(this.state)
        if (resp.IsValid == true && this.props.match.params.id == null)
            this.props.history.push(`Modifica/${resp.Id}`)
    }

    toggleModal = (visible: boolean) => {
        this.setState({ ModalVisible: visible })
    }

    renderWithId = () => {
        if (this.props.match.params.id == null) return

        return (
            <>
                <PageHeader title="Ruoli" extra={[
                    <Button type="primary" key="add" icon={<PlusOutlined />} onClick={() => this.toggleModal(true)}>Aggiungi</Button>
                ]}>
                    <ListClienteRole list={this.state.RuoloClientiList} />
                </PageHeader>

                <ModalClienteRoleBackoffice
                    visible={this.state.ModalVisible}
                    closeModal={() => this.toggleModal(false)}
                    do={() => this.loadPage()}
                />
            </>
        )
    }

    render() {
        return (
            <>
                <PageHeader title="Utente" onBack={() => this.props.history.push(`/UtentiBackoffice`)} extra={[
                    <Button type="primary" key="save" icon={<SaveOutlined />} onClick={() => this.onSaveClick()}>Salva</Button>
                ]}>
                    <Form>
                        <FormUtente
                            nominativo={this.state.Nominativo} onNominativoChange={e => this.setState({ Nominativo: e })}
                            username={this.state.Username} onUsernameChange={e => this.setState({ Username: e })}
                            email={this.state.Email} onEmailChange={e => this.setState({ Email: e })} />
                        <span style={{color:"white"}}>{this.state.Password}</span>
                    </Form>
                </PageHeader>
                { this.renderWithId()}
            </>
        )
    }
}

export const PageUtenteEditBackoffice = withRouter(withAITracking(ai.reactPlugin, PageUtenteEditBackofficeComp,"PageUtenteEditBackoffice"))
